import { t } from 'i18next'

import { formatDateToString } from '~/helpers'
import { isNewItem } from '~/helpers/isNewItem'

import * as S from './styles'

export const TagNewItem = ({
  created,
  showBadgeNew = true
}: {
  created: string
  showBadgeNew?: boolean
}) => {
  const newItem = isNewItem({ date: created, daysThreshold: 1 }) && showBadgeNew

  return (
    newItem && (
      <S.Container
        title={`${t('c:terms.created_at')} ${formatDateToString(created, t('c:patterns.date.short'))}`}
      >
        <span>{t('rm:New')}</span>
      </S.Container>
    )
  )
}
